import React, { useEffect, useState } from "react";
import { Plus, Trash2, Image as ImgIcon } from "lucide-react";
import api from "../../lib/api";

const fileToBase64 = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });

export default function AdminPartners() {
    const [list, setList] = useState([]);
    const [form, setForm] = useState({ name: "", logo_base64: "", link: "", tier: "bronze" });
    const load = () => api.get("/partners").then(r => setList(r.data));
    useEffect(() => { load(); }, []);
    const save = async (e) => { e.preventDefault(); await api.post("/partners", form); setForm({ name: "", logo_base64: "", link: "", tier: "bronze" }); load(); };
    const del = async (id) => { await api.delete(`/partners/${id}`); load(); };
    const onFile = async (e) => { const f = e.target.files[0]; if (!f) return; setForm({ ...form, logo_base64: await fileToBase64(f) }); };
    return (
        <div data-testid="admin-partners">
            <h1 className="font-display text-4xl uppercase tracking-widest mb-6">Partenaires</h1>
            <form onSubmit={save} className="glass-card p-5 grid sm:grid-cols-5 gap-3 mb-6 items-center">
                <input required className="input-field" placeholder="Nom" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
                <input className="input-field" placeholder="Lien (https://...)" value={form.link} onChange={e => setForm({ ...form, link: e.target.value })} />
                <select className="input-field" value={form.tier} onChange={e => setForm({ ...form, tier: e.target.value })}>
                    <option value="platinum">Platine</option><option value="gold">Or</option><option value="silver">Argent</option><option value="bronze">Bronze</option>
                </select>
                <label className="btn-ghost cursor-pointer flex items-center gap-2 justify-center"><ImgIcon size={14} />Logo<input type="file" accept="image/*" onChange={onFile} className="hidden" /></label>
                <button type="submit" className="btn-primary justify-center"><Plus size={14} /> Ajouter</button>
            </form>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
                {list.map(p => (
                    <div key={p.id} className="glass-card p-4 flex items-center gap-3">
                        {p.logo_base64 ? <img src={p.logo_base64} alt="" className="h-12 max-w-[80px] object-contain" /> : <div className="h-12 w-20 bg-black/40 flex items-center justify-center text-xs">{p.name}</div>}
                        <div className="flex-1 min-w-0">
                            <div className="font-display text-lg uppercase truncate">{p.name}</div>
                            <div className="text-xs text-white/50 capitalize">{p.tier}</div>
                        </div>
                        <button onClick={() => del(p.id)} className="btn-ghost text-rose-400 border-rose-400/30"><Trash2 size={12} /></button>
                    </div>
                ))}
            </div>
        </div>
    );
}
